module.exports = __webpack_public_path__ + "static/sport/toast-4.0282974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/toast-4.png
// module id = pHOz
// module chunks = 0